// extracted by mini-css-extract-plugin
export default {"slideContainer":"s_slideContainer__uMJvL"};